
export const recreationCategories = [
  'All',
  'Parks & Trails',
  'Aquatics',
  'Sports',
  'Golf',
  'Fitness',
  'Youth Programs'
];

export const recreationFacilities = [
  {
    id: 1,
    name: 'Maidu Regional Park',
    category: 'Parks & Trails',
    description: 'A 152-acre park featuring sports fields, playgrounds, picnic areas, and the Maidu Museum & Historic Site showcasing Native American heritage.',
    image: 'https://public.readdy.ai/ai/img_res/3d83303bc409952850a7510edfd07101.jpg',
    address: '1550 Maidu Dr, Roseville, CA 95661',
    hours: '6:00 AM - 10:00 PM Daily',
    amenities: ['Sports Fields', 'Playgrounds', 'Picnic Areas', 'Restrooms', 'Parking', 'Dog Park'],
    phone: '(916) 774-5950',
    featured: true
  },
  {
    id: 2,
    name: 'Roseville Aquatics Complex',
    category: 'Aquatics',
    description: 'State-of-the-art aquatic facility with competition pool, recreation pool, water slides, lazy river, and splash pad for all ages.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20aquatic%20center%20with%20Olympic%20swimming%20pool%2C%20water%20slides%2C%20lazy%20river%2C%20splash%20pad%20area%2C%20families%20swimming%2C%20lifeguard%20stations%2C%20sunny%20day%2C%20blue%20water%20sparkling&width=600&height=400&seq=rec002&orientation=landscape',
    address: '951 Oak Ridge Dr, Roseville, CA 95661',
    hours: 'Mon-Fri 5:30 AM - 9:00 PM, Sat-Sun 8:00 AM - 6:00 PM',
    amenities: ['Competition Pool', 'Recreation Pool', 'Water Slides', 'Lazy River', 'Splash Pad', 'Locker Rooms'],
    phone: '(916) 774-5950',
    featured: true
  },
  {
    id: 3,
    name: 'Diamond Oaks Golf Course',
    category: 'Golf',
    description: 'Championship 18-hole golf course with driving range, practice facilities, pro shop, and restaurant with stunning Sierra foothill views.',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20golf%20course%20with%20manicured%20green%20fairways%2C%20sand%20bunkers%2C%20oak%20trees%20lining%20the%20course%2C%20golfers%20playing%2C%20Sierra%20Nevada%20foothills%20in%20background%2C%20clear%20blue%20sky&width=600&height=400&seq=rec003&orientation=landscape',
    address: '79 Clover Valley Rd, Roseville, CA 95678',
    hours: 'Dawn to Dusk Daily',
    amenities: ['18 Holes', 'Driving Range', 'Pro Shop', 'Restaurant', 'Golf Carts', 'Lessons'],
    phone: '(916) 783-4947',
    featured: true
  },
  {
    id: 4,
    name: 'Mahany Park & Community Center',
    category: 'Fitness',
    description: 'Premier community center with fitness center, gymnasium, indoor track, dance studios, and extensive recreation programs.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20community%20recreation%20center%20building%20with%20glass%20windows%2C%20fitness%20equipment%20visible%20inside%2C%20outdoor%20park%20area%20with%20walking%20paths%2C%20families%20entering%20building&width=600&height=400&seq=rec004&orientation=landscape',
    address: '1545 Pleasant Grove Blvd, Roseville, CA 95747',
    hours: 'Mon-Fri 5:00 AM - 10:00 PM, Sat 7:00 AM - 7:00 PM, Sun 8:00 AM - 6:00 PM',
    amenities: ['Fitness Center', 'Gymnasium', 'Indoor Track', 'Dance Studios', 'Meeting Rooms'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 5,
    name: 'Miners Ravine Trail',
    category: 'Parks & Trails',
    description: 'Scenic 7-mile paved trail perfect for walking, jogging, and cycling through beautiful oak woodlands and creek crossings.',
    image: 'https://readdy.ai/api/search-image?query=Scenic%20paved%20walking%20trail%20through%20oak%20woodland%2C%20creek%20crossing%20with%20wooden%20bridge%2C%20cyclists%20and%20joggers%20on%20path%2C%20dappled%20sunlight%20through%20trees%2C%20California%20nature&width=600&height=400&seq=rec005&orientation=landscape',
    address: 'Miners Ravine Trail, Roseville, CA 95661',
    hours: 'Sunrise to Sunset',
    amenities: ['Paved Trail', 'Bike Friendly', 'Creek Access', 'Benches', 'Nature Views'],
    phone: '(916) 774-5950',
    featured: true
  },
  {
    id: 6,
    name: 'Mike Shellito Indoor Pool',
    category: 'Aquatics',
    description: 'Year-round indoor heated pool offering lap swimming, water aerobics, swim lessons, and therapeutic programs.',
    image: 'https://readdy.ai/api/search-image?query=Indoor%20swimming%20pool%20facility%20with%20lap%20lanes%2C%20swimmers%20doing%20laps%2C%20large%20windows%20letting%20in%20natural%20light%2C%20modern%20pool%20building%20interior%2C%20clean%20blue%20water&width=600&height=400&seq=rec006&orientation=landscape',
    address: '9200 Oak Ridge Dr, Roseville, CA 95661',
    hours: 'Mon-Fri 5:30 AM - 8:30 PM, Sat-Sun 8:00 AM - 5:00 PM',
    amenities: ['Heated Pool', 'Lap Lanes', 'Swim Lessons', 'Water Aerobics', 'Locker Rooms'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 7,
    name: 'Roseville Sports Center',
    category: 'Sports',
    description: 'Multi-sport facility featuring basketball courts, volleyball courts, indoor soccer, and youth sports leagues.',
    image: 'https://readdy.ai/api/search-image?query=Indoor%20sports%20facility%20with%20basketball%20courts%2C%20volleyball%20nets%2C%20people%20playing%20sports%2C%20modern%20gymnasium%20lighting%2C%20hardwood%20floors%2C%20athletic%20activities&width=600&height=400&seq=rec007&orientation=landscape',
    address: '1545 Pleasant Grove Blvd, Roseville, CA 95747',
    hours: 'Mon-Fri 6:00 AM - 10:00 PM, Sat-Sun 8:00 AM - 8:00 PM',
    amenities: ['Basketball Courts', 'Volleyball Courts', 'Indoor Soccer', 'Youth Leagues', 'Equipment Rental'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 8,
    name: 'Woodcreek Oaks Golf Club',
    category: 'Golf',
    description: 'Beautiful 18-hole public golf course with challenging layout, practice facilities, and full-service clubhouse.',
    image: 'https://readdy.ai/api/search-image?query=Scenic%20golf%20course%20with%20rolling%20green%20hills%2C%20water%20hazard%20with%20fountain%2C%20golfers%20on%20fairway%2C%20oak%20trees%2C%20clubhouse%20in%20background%2C%20beautiful%20California%20weather&width=600&height=400&seq=rec008&orientation=landscape',
    address: '5880 Woodcreek Oaks Blvd, Roseville, CA 95747',
    hours: 'Dawn to Dusk Daily',
    amenities: ['18 Holes', 'Practice Green', 'Clubhouse', 'Pro Shop', 'Restaurant'],
    phone: '(916) 771-4653',
    featured: false
  },
  {
    id: 9,
    name: 'Roseville Youth Sports Complex',
    category: 'Youth Programs',
    description: 'Dedicated youth sports facility with baseball diamonds, soccer fields, and comprehensive youth athletic programs.',
    image: 'https://readdy.ai/api/search-image?query=Youth%20sports%20complex%20with%20baseball%20diamonds%2C%20soccer%20fields%2C%20children%20playing%20sports%2C%20parents%20watching%20from%20bleachers%2C%20green%20grass%20fields%2C%20sunny%20day&width=600&height=400&seq=rec009&orientation=landscape',
    address: '1000 Kaseberg Dr, Roseville, CA 95747',
    hours: 'Varies by Season',
    amenities: ['Baseball Diamonds', 'Soccer Fields', 'Concessions', 'Restrooms', 'Parking'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 10,
    name: 'Dry Creek Parkway Trail',
    category: 'Parks & Trails',
    description: 'Popular multi-use trail system connecting neighborhoods with parks, offering scenic views and wildlife watching opportunities.',
    image: 'https://readdy.ai/api/search-image?query=Scenic%20parkway%20trail%20along%20creek%2C%20native%20California%20vegetation%2C%20people%20walking%20dogs%2C%20cyclists%20on%20path%2C%20wildlife%20birds%2C%20natural%20landscape%2C%20peaceful%20setting&width=600&height=400&seq=rec010&orientation=landscape',
    address: 'Dry Creek Parkway, Roseville, CA 95747',
    hours: 'Sunrise to Sunset',
    amenities: ['Multi-Use Trail', 'Wildlife Viewing', 'Dog Friendly', 'Creek Access', 'Benches'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 11,
    name: 'Johnson Pool',
    category: 'Aquatics',
    description: 'Community outdoor pool with swim lessons, recreational swimming, and summer programs for families.',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20community%20swimming%20pool%20with%20families%20swimming%2C%20lifeguard%20on%20duty%2C%20pool%20deck%20with%20lounge%20chairs%2C%20summer%20day%2C%20children%20playing%20in%20water&width=600&height=400&seq=rec011&orientation=landscape',
    address: '701 Cirby Way, Roseville, CA 95678',
    hours: 'Seasonal: June - August',
    amenities: ['Outdoor Pool', 'Swim Lessons', 'Family Swim', 'Shade Structures', 'Snack Bar'],
    phone: '(916) 774-5950',
    featured: false
  },
  {
    id: 12,
    name: 'Roseville Tennis Center',
    category: 'Sports',
    description: 'Premier tennis facility with lighted courts, lessons, leagues, and tournaments for all skill levels.',
    image: 'https://readdy.ai/api/search-image?query=Tennis%20courts%20with%20players%2C%20green%20hard%20courts%2C%20tennis%20nets%2C%20people%20playing%20doubles%2C%20modern%20tennis%20facility%2C%20lighting%20poles%2C%20California%20sunshine&width=600&height=400&seq=rec012&orientation=landscape',
    address: '1000 Kaseberg Dr, Roseville, CA 95747',
    hours: '7:00 AM - 10:00 PM Daily',
    amenities: ['Lighted Courts', 'Pro Shop', 'Lessons', 'Leagues', 'Court Reservations'],
    phone: '(916) 774-5950',
    featured: false
  }
];

export const recreationPrograms = [
  {
    id: 1,
    name: 'Youth Sports Leagues',
    description: 'Organized sports leagues for children ages 4-17 including soccer, basketball, baseball, and flag football.',
    icon: 'ri-football-line',
    ageGroup: 'Ages 4-17'
  },
  {
    id: 2,
    name: 'Swim Lessons',
    description: 'Learn-to-swim programs for all ages and skill levels, from infant water safety to advanced stroke technique.',
    icon: 'ri-swim-line',
    ageGroup: 'All Ages'
  },
  {
    id: 3,
    name: 'Fitness Classes',
    description: 'Group fitness classes including yoga, pilates, spinning, Zumba, and strength training.',
    icon: 'ri-heart-pulse-line',
    ageGroup: 'Adults'
  },
  {
    id: 4,
    name: 'Summer Camps',
    description: 'Day camps offering sports, arts, nature exploration, and adventure activities during summer break.',
    icon: 'ri-sun-line',
    ageGroup: 'Ages 5-14'
  },
  {
    id: 5,
    name: 'Senior Programs',
    description: 'Active aging programs including fitness classes, social activities, and educational workshops.',
    icon: 'ri-user-heart-line',
    ageGroup: 'Ages 55+'
  },
  {
    id: 6,
    name: 'Art & Dance Classes',
    description: 'Creative programs including painting, pottery, ballet, hip-hop, and performing arts.',
    icon: 'ri-palette-line',
    ageGroup: 'All Ages'
  }
];
